import * as measurementService from '../../../../services/measurement.services';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { ERROR_MESSAGE, getApiErrorKey, backendErrorMsg } from '../../../../Components/helper';
import { HTTP_STATUS } from '../../../../constants/api-status-codes';
import type from './Measurment.type';
import devOrderType from '../../store/DevelopmentOrder.type';

export const addSpecDocument = (data, t) => async () => {
  try {
    const res = await measurementService.addSpecDocument(data);
    if (res?.code === 200 && res.data) {
      const msg = t(`MEASUREMENT.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = t(`MEASUREMENT.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getMeasurementDocument = (devOrderId, gradingGroupId, t) => async () => {
  const params = {
    devOrderId,
    gradingGroupId,
  };
  try {
    const res = await measurementService.getMeasurementDocument({ params });
    if (res?.code === 200 && res.data) {
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = t(`MEASUREMENT.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateMeasurementDocuments = (data, t) => async () => {
  try {
    const res = await measurementService.updateMeasurementDocuments(data);
    if (res?.code === 200 && res.data) {
      const msg = t(`MEASUREMENT.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = t(`MEASUREMENT.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteMeasurementDocument = (data, t) => async () => {
  try {
    const res = await measurementService.deleteMeasurementDocument(data);
    if (res?.code === 200 && res.data) {
      const msg = t(`MEASUREMENT.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = t(`MEASUREMENT.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateDocumentStatus = (data, t) => async () => {
  try {
    const res = await measurementService.updateDocumentStatus(data);
    if (res?.code === 200 && res.data) {
      const msg = t(`MEASUREMENT.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = t(`MEASUREMENT.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllActiveDocuments = (devOrderId) => async () => {
  const params = {
    devOrderId,
    isActive: true,
  };
  try {
    const res = await measurementService.getMeasurementDocument({ params });
    if (res?.code === 200 && res.data) {
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = res.data.errMsg;
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getDevOrderGradingGroups = (data, t) => async (dispatch) => {
  try {
    const res = await measurementService.getDevOrderGradingGroups(data);
    if (res?.code === 200 && res.data) {
      await dispatch({ type: type.ORDER_GRADING_GROUPS, payload: res.data });
    }
    if (res?.data?.errMsg) {
      const msg = t(`MEASUREMENT.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateDevOrderGradingGroups = (data, t) => async () => {
  try {
    const res = await measurementService.updateDevOrderGradingGroups(data);
    if (res?.code === 200 && res.data) {
      const msg = t(`MEASUREMENT.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = t(`MEASUREMENT.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
  } catch (err) {
    toasterMsg(backendErrorMsg(t, `MEASUREMENT.${getApiErrorKey(err)}`), 'danger');
  }
};

export const updateProductIdentifier = (data, t) => async () => {
  try {
    const res = await measurementService.updateProductIdentifier(data);
    if (res?.code === 200 && res.data) {
      const msg = t(`MEASUREMENT.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      const msg = t(`MEASUREMENT.${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
      return res;
    }
    if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (err) {
    toasterMsg(err?.message || err.toString(), 'danger');
  }
};

/**
 * Saves the newly selected base/sample size for a grading group.
 * The resolved res.data is Array<{code, gradings, ...}> — the re-derived pom rows
 * the server recalculated for the new base size — not a message string.
 *
 * A failure is reported and RETHROWN rather than swallowed. Returning `undefined` on failure
 * made a server-side error indistinguishable from "no rows needed re-deriving", so the caller
 * kept the newly clicked base size in local state and the user saw the change apparently
 * succeed while nothing had been persisted (BM-9510). The caller needs the throw to roll the
 * optimistic flip back.
 * @param {Object} data - devOrderId, gradingGroupId, oldSampleSizeName, newSampleSizeName.
 * @param {Function} t - i18n translate function used for the toaster message only.
 * @returns {Function} thunk resolving to the API envelope.
 * @throws {Error} when the server did not confirm the change.
 */
/**
 * Patches the loaded per-grading-group hidden-size map without touching the server.
 *
 * Used to reflect a hide the instant the user clicks, while the write itself is debounced — the
 * multiselect and the grading group tabs both read this map, so leaving it stale for the debounce
 * window would let the size the user just removed flicker back.
 * @param {Object<string, string[]>} patch - Hidden size names keyed by grading group id.
 * @returns {{type: string, payload: Object}} redux action.
 */
export const patchHiddenSizesByGroup = (patch) => ({
  type: devOrderType.MEASUREMENT_HIDDEN_SIZES_BY_GROUP,
  payload: patch,
});

/**
 * Persists the hidden-size list of one or more grading groups, and patches the loaded per-group
 * map so the screen agrees with the database immediately.
 *
 * The ordinary spec save only speaks for the grading group whose tab is open, so a size hidden on
 * a different selected grading group had no way to reach the server and reappeared the moment the
 * user switched to that group's tab (BM-9510). The optimistic patch is applied first so the
 * multiselect and the tab both settle at once; a failed request rolls it back and reports.
 * @param {{devOrderId: string, groups: Array<{gradingGroupId: string, hiddenSizeNames: string[]}>}} data
 * @param {Object<string, string[]>} previousHiddenByGroup - Map to restore if the request fails.
 * @param {Function} t - i18n translate function, used for the failure message only.
 * @returns {Function} thunk resolving to the API envelope.
 */
export const updateHiddenSizes = (data, previousHiddenByGroup, t) => async (dispatch) => {
  const optimisticPatch = (data?.groups || []).reduce((patch, group) => {
    patch[String(group.gradingGroupId)] = group.hiddenSizeNames || [];
    return patch;
  }, {});
  dispatch({ type: devOrderType.MEASUREMENT_HIDDEN_SIZES_BY_GROUP, payload: optimisticPatch });
  try {
    const res = await measurementService.updateHiddenSizes(data);
    if (res?.code === 200) {
      return res;
    }
    throw new Error(res?.data?.errMsg || res?.message || ERROR_MESSAGE);
  } catch (err) {
    if (previousHiddenByGroup) {
      const rollback = Object.keys(optimisticPatch).reduce((patch, gradingGroupId) => {
        patch[gradingGroupId] = previousHiddenByGroup[gradingGroupId] || [];
        return patch;
      }, {});
      dispatch({ type: devOrderType.MEASUREMENT_HIDDEN_SIZES_BY_GROUP, payload: rollback });
    }
    toasterMsg(err?.message || t('MEASUREMENT.SIZE_VISIBILITY_SAVE_FAILED'), 'danger');
    throw err;
  }
};

export const updateSampleSizeChanged = (data, t) => async () => {
  try {
    const res = await measurementService.updateSampleSizeChanged(data);
    if (res?.code === 200) {
      const msg = t(`MEASUREMENT.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    throw new Error(res?.data?.errMsg || t('specification:SAMPLE_SIZE.CHANGE_FAILED'));
  } catch (err) {
    toasterMsg(err?.message || t('specification:SAMPLE_SIZE.CHANGE_FAILED'), 'danger');
    throw err;
  }
};

const parseErrorBody = (errorData) => {
  if (typeof errorData === 'string') {
    try {
      return JSON.parse(errorData);
    } catch {
      return {};
    }
  }
  return errorData ?? {};
};

const getErrorMessage = (result, errMsg) => {
  if (result.statusCode === HTTP_STATUS.NOT_FOUND) {
    return 'Sample size name not found';
  }
  if (result.statusCode === HTTP_STATUS.BAD_REQUEST) {
    return errMsg ?? 'Bad request';
  }
  return errMsg ?? 'Something went wrong. Please try again.';
};

export const getSampleSizeName = (data, t) => async (dispatch) => {
  try {
    const result = await measurementService.getSampleSizeName(data);
    if (result?.success && result?.statusCode === HTTP_STATUS.OK) {
      const responseData = result;
      if (responseData?.data?.code === 200) {
        await dispatch({ type: type.GET_SAMPLE_SIZE_NAME, payload: responseData.data.data });
        return responseData.data;
      }
    }
    if (!result.success) {
      const body = parseErrorBody(result.data);
      const errMsg = body?.data?.errMsg ?? body?.message;
      const msg = getErrorMessage(result, errMsg);

      if (t && errMsg) {
        const translatedMsg = t(`MEASUREMENT.${errMsg}`);
        toasterMsg(translatedMsg, 'danger');
      } else {
        toasterMsg(msg, 'danger');
      }
    }
    return [];
  } catch (error) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
